import { render, staticRenderFns } from "./StaticCoupons.vue?vue&type=template&id=4474bf53&"
import script from "./StaticCoupons.vue?vue&type=script&lang=js&"
export * from "./StaticCoupons.vue?vue&type=script&lang=js&"
import style0 from "./StaticCoupons.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports